class FumiAsSeenOn {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-fumi-seen-track]');
    this.prevBtn = root.querySelector('[data-fumi-seen-prev]');
    this.nextBtn = root.querySelector('[data-fumi-seen-next]');

    if (!this.track) return;

    this.prevBtn?.addEventListener('click', () => this.scroll(-1));
    this.nextBtn?.addEventListener('click', () => this.scroll(1));
    this.track.addEventListener('scroll', () => this.updateNav(), { passive: true });
    window.addEventListener('resize', () => this.updateNav());

    this.updateNav();
  }

  getScrollStep() {
    const slide = this.track.querySelector('.seen-slide');
    if (!slide) return 0;
    const gap = parseFloat(getComputedStyle(this.track).gap) || 12;
    return slide.offsetWidth + gap;
  }

  scroll(direction) {
    const step = this.getScrollStep();
    if (!step) return;
    this.track.scrollBy({ left: direction * step, behavior: 'smooth' });
  }

  updateNav() {
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    const atStart = this.track.scrollLeft <= 1;
    const atEnd = this.track.scrollLeft >= maxScroll - 1;

    if (this.prevBtn) this.prevBtn.disabled = atStart;
    if (this.nextBtn) this.nextBtn.disabled = atEnd || maxScroll <= 0;
  }
}

function initFumiAsSeenOn(scope = document) {
  scope.querySelectorAll('[data-fumi-seen-on]').forEach((root) => {
    if (root.dataset.fumiSeenOnInit === 'true') return;
    root.dataset.fumiSeenOnInit = 'true';
    new FumiAsSeenOn(root);
  });
}

document.addEventListener('DOMContentLoaded', () => initFumiAsSeenOn());

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initFumiAsSeenOn(event.target));
}
